//菜单：邮件管理
import React from 'react'
import Manager from '../../public/components/Manager'
import EmailDiv from '../SysManage/EmailDiv'
Ext.require('Ext.Toast')


const config = {
  buttons: [
  ],
  columns: [
    { _text: '邮件主题', minWidth: 300, search: true },
    { _text: '模板名称', minWidth: 100, flex: 1, search: true },
    { _text: '状态', minWidth: 100, flex: 1, search: true },
    { _text: '发送者邮箱', minWidth: 100, flex: 1, search: true },
    { _text: '收邮件邮箱', minWidth: 100, flex: 1, search: true },
    { _text: '发送次数', minWidth: 100, flex: 1 },
  ],
  onDoubleTap: ({ showDetail, refreshPage }, data) => {
    Tyan.pubForm.showDialog('邮件信息', props => <EmailDiv {...props} id={data.id} onSave={refreshPage} />)
  }
}




export default props => <Manager {...props} config={config} />